import { RankData } from '../rank-card.service'

export const MockUseRecordType2: { view_infos: RankData[] } = {
  'view_infos': [
    {
      'name': '微信',
      'value': 39
    },
    {
      'name': 'TIM',
      'value': 14
    },
    {
      'name': 'QQ',
      'value': 13
    }
  ]
}
